/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllMutatableEntityAssignmentsResponse } from '../../models/get-all-mutatable-entity-assignments-response';

export interface GetMutatableEntityAssignmentsByOrganizationIdAndAuthorizedParty$Params {
  organizationId: string;
  authorizedParty: string;
}

export function getMutatableEntityAssignmentsByOrganizationIdAndAuthorizedParty(http: HttpClient, rootUrl: string, params: GetMutatableEntityAssignmentsByOrganizationIdAndAuthorizedParty$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllMutatableEntityAssignmentsResponse>> {
  const rb = new RequestBuilder(rootUrl, getMutatableEntityAssignmentsByOrganizationIdAndAuthorizedParty.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('authorizedParty', params.authorizedParty, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllMutatableEntityAssignmentsResponse>;
    })
  );
}

getMutatableEntityAssignmentsByOrganizationIdAndAuthorizedParty.PATH = '/v1/organizations/{organizationId}/graphql/mutatableEntityAssignments/{authorizedParty}';
